export default "__VITE_ASSET__BM$kjptR__"